export function showIt(id) {
  let elem = document.getElementById(id)
  elem.style.display = "block"
  let ff = function () {
    elem.classList.add('show')
  }
  setTimeout(ff, 10)
}
export function hideIt(id, duration) {
  let elem = document.getElementById(id)
  elem.classList.remove('show')
  let ff = function () {
    elem.style.display = "none"
  }
  setTimeout(ff, duration)
}

export function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function zeroWriter(num) {
  if (num < 10) {
    return '0' + num
  }
  return '' + num
}

export function preloadImage(url) {
    var img=new Image();
    img.src=url;
}

export function monthText(month_year) {
  let month_year_splitted = month_year.split(".")
  let year = month_year_splitted[1]
  let month = month_year_splitted[0]
  let month_txt = ""
  if (month == "01") {
    month_txt = "Январь"
  } else if (month == "02") {
    month_txt = "Февраль"
  } else if (month == "03") {
    month_txt = "Март"
  } else if (month == "04") {
    month_txt = "Апрель"
  } else if (month == "05") {
    month_txt = "Май"
  } else if (month == "06") {
    month_txt = "Июнь"
  } else if (month == "07") {
    month_txt = "Июль"
  } else if (month == "08") {
    month_txt = "Август"
  } else if (month == "09") {
    month_txt = "Сентябрь"
  } else if (month == "10") {
    month_txt = "Октябрь"
  } else if (month == "11") {
    month_txt = "Ноябрь"
  } else if (month == "12") {
    month_txt = "Декабрь"
  }
  return month_txt + " " + year
}

export function isArrayEqual(array1, array2) {
  return JSON.stringify(array1) === JSON.stringify(array2);
}
